<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-4 m-lg-3">
          <div class="card-body">
            <div class="row align-items-center rental-payment">
              <div class="col mt-4 d-none d-sm-block">
                <h4 class="ms-2">Add {{ capitalizedRole }} Details</h4>
              </div>
              <div class="col mt-4 d-block d-sm-none">
                <h4 class="ms-2 no-wrap-heading">Add {{ capitalizedRole }}</h4>
              </div>
              <div class="col d-flex justify-content-end">
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary me-2 d-none d-sm-block new-btn"
                  @click="BackToUserDetails()"
                >
                  Back To {{ capitalizedRole }}
                </llp-button>

                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary me-2 d-block d-sm-none new-btn"
                  @click="BackToUserDetails()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>

            <form ref="laddadmin" class="d-grid" @submit.prevent="addAdmin">
              <div class="row p-2">
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="firstName" :aria-label="FirstName">
                    First Name:
                  </llp-label>
                  <llp-input
                    id="firstName"
                    v-model:modelValue="adminData.firstName"
                    :errors="validator.adminData.firstName.$errors"
                  ></llp-input>
                  <div v-if="formErrors.firstName" class="text-danger">
                    <span>{{ formErrors.firstName[0] }}</span>
                  </div>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="lastName" :aria-label="LastName">
                    Last Name:
                  </llp-label>
                  <llp-input
                    id="lastName"
                    v-model:modelValue="adminData.lastName"
                    :errors="validator.adminData.lastName.$errors"
                  ></llp-input>
                  <div v-if="formErrors.lastName" class="text-danger">
                    <span>{{ formErrors.lastName[0] }}</span>
                  </div>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="mobile" :aria-label="Email">
                    Mobile:
                  </llp-label>
                  <llp-input
                    id="mobile"
                    v-model:modelValue="adminData.mobile"
                    :errors="validator.adminData.mobile.$errors"
                  ></llp-input>
                  <div v-if="formErrors.mobile" class="text-danger">
                    <span>{{ formErrors.mobile[0] }}</span>
                  </div>
                </div>
              </div>
              <div class="row p-2">
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="address" :aria-label="Address">
                    Address:
                  </llp-label>
                  <llp-input
                    id="address"
                    v-model:modelValue="adminData.address"
                    :errors="validator.adminData.address.$errors"
                  ></llp-input>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="city" :aria-label="City"> City: </llp-label>
                  <llp-input
                    id="City"
                    v-model:modelValue="adminData.city"
                    :errors="validator.adminData.city.$errors"
                  ></llp-input>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="state" :aria-label="State"> State: </llp-label>
                  <select
                    id="state"
                    class="form-control select-dropdown"
                    v-model="adminData.state"
                    :errors="validator.adminData.state.$errors"
                  >
                    <option value="" disabled selected>
                      Select your state
                    </option>
                    <option value="Andhra Pradesh">Andhra Pradesh</option>
                    <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                    <option value="Assam">Assam</option>
                    <option value="Bihar">Bihar</option>
                    <option value="Chhattisgarh">Chhattisgarh</option>
                    <option value="Goa">Goa</option>
                    <option value="Gujarat">Gujarat</option>
                    <option value="Haryana">Haryana</option>
                    <option value="Himachal Pradesh">Himachal Pradesh</option>
                    <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                    <option value="Jharkhand">Jharkhand</option>
                    <option value="Karnataka">Karnataka</option>
                    <option value="Kerala">Kerala</option>
                    <option value="Madhya Pradesh">Madhya Pradesh</option>
                    <option value="Maharashtra">Maharashtra</option>
                    <option value="Manipur">Manipur</option>
                    <option value="Meghalaya">Meghalaya</option>
                    <option value="Mizoram">Mizoram</option>
                    <option value="Nagaland">Nagaland</option>
                    <option value="Odisha">Odisha</option>
                    <option value="Punjab">Punjab</option>
                    <option value="Rajasthan">Rajasthan</option>
                    <option value="Sikkim">Sikkim</option>
                    <option value="Tamil Nadu">Tamil Nadu</option>
                    <option value="Telangana">Telangana</option>
                    <option value="Tripura">Tripura</option>
                    <option value="Uttar Pradesh">Uttar Pradesh</option>
                    <option value="Uttarakhand">Uttarakhand</option>
                    <option value="West Bengal">West Bengal</option>
                    <option value="Chandigarh">Chandigarh</option>
                    <option value="Lakshadweep">Lakshadweep</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Puducherry">Puducherry</option>
                  </select>
                  <div
                    v-if="validator.adminData.state.$invalid"
                    class="text-danger"
                  >
                    {{ validator.adminData.state.$errors[0]?.$message }}
                  </div>
                </div>
              </div>
              <div class="row p-2">
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="pinCode" :aria-label="PinCode">
                    Pincode:
                  </llp-label>
                  <llp-input
                    id="pinCode"
                    v-model:modelValue="adminData.pinCode"
                    :errors="validator.adminData.pinCode.$errors"
                  ></llp-input>
                  <div v-if="formErrors.pincode" class="text-danger">
                    <span>{{ formErrors.pincode[0] }}</span>
                  </div>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="email" :aria-label="email"> Email: </llp-label>
                  <llp-input
                    id="email"
                    v-model:modelValue="adminData.email"
                    :errors="validator.adminData.email.$errors"
                  ></llp-input>
                  <div v-if="formErrors.email" class="text-danger">
                    <span>{{ formErrors.email[0] }}</span>
                  </div>
                </div>
                     <div class="col-lg-4 col-md-4 col-sm-6" v-if="roleName === 'retailer' && this.login_user_role_id == '2'">
                  <llp-label id="distributor" :aria-label="Distributor">
                    Distributor:
                  </llp-label>
                  <select
                    id="distributor"
                    class="form-control select-dropdown"
                    v-model="adminData.distributor"
                  >
                    <option value="" disabled selected>
                      Select Distributor
                    </option>
                    <option
                      v-for="distributor in Distributors"
                      :key="distributor.id"
                      :value="distributor.id"
                    >
                      {{ distributor.name }}
                    </option>
                  </select>
                   <div v-if="validator.adminData.distributor?.$invalid" class="text-danger">
                    {{ validator.adminData.distributor?.$errors[0]?.$message }}
                  </div>
                </div>
                 <div class="col-lg-4 col-md-4 col-sm-6"  v-if="roleName === 'distributor' && this.login_user_role_id == '2'">
                  <llp-label id="commissionLabel" :aria-label="Commission" >
                    Commission(%):
                  </llp-label>
                  <llp-input
                    id="CommissionId"
                    v-model:modelValue="adminData.Commission"
                     :errors="validator.adminData.Commission?.$errors"
                  >
                  </llp-input>
                  <!-- <div v-if="formErrors.Commission" class="text-danger">
                    <span>{{ formErrors.Commission[0] }}</span>
                  </div> -->
                </div>
                <!-- <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="status" :aria-label="Staus">
                    Status:
                  </llp-label>
                  <select
                    id="status"
                    class="form-control select-dropdown"
                    v-model="adminData.status"
                  >
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                  </select>
                </div> -->
              </div>

              <!-- <div class="row p-2" v-if="addUserRole === 'distributor'">
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="admin" :aria-label="Admin"> Admin: </llp-label>

                  <select
                    id="admin"
                    class="form-control select-dropdown"
                    v-model="adminData.admin"
                  >
                    <option value="" disabled selected>Select admin</option>
                    <option
                      v-for="admin in activeAdmins"
                      :key="admin.id"
                      :value="admin.username"
                    >
                      {{ admin.name }}
                    </option>
                  </select>
                </div>
              </div> -->
              <!-- <div class="row p-2" v-if="roleName === 'retailer'"> -->
                <!-- <div class="col-lg-4 col-md-4 col-sm-6">
                  <llp-label id="admin" :aria-label="Admin"> Admin: </llp-label>
                  <select
                    id="admin"
                    class="form-control select-dropdown"
                    v-model="adminData.admin"
                  >
                    <option value="" disabled selected>Select Admin</option>
                    <option
                      v-for="admin in Admins"
                      :key="admin.id"
                      :value="admin.username"
                    >
                      {{ admin.name }}
                    </option>
                  </select>
                </div> -->

             
              <!-- </div> -->
              <!-- <h5 class="ms-2">Business Details</h5>
            <div class="row p-2">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="businessName" :aria-label="BusinessName">
                  Business Name:
                </llp-label>
                <llp-input
                  id="businessName"
                  v-model:modelValue="adminData.businessName"
                ></llp-input>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="contactNumber" :aria-label="ContactNumber">
                  Contact Number:
                </llp-label>
                <llp-input
                  id="contactNumber"
                  v-model:modelValue="adminData.contactNumber"
                  maxlength="10"
                ></llp-input>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="businessAddress" :aria-label="BusinessAddress">
                  BusinessAddress:
                </llp-label>
                <llp-input
                  id="businessAddress"
                  v-model:modelValue="adminData.businessAddress"
                ></llp-input>
              </div>
            </div>
            <div class="row p-2">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label
                  id="gst"
                  :aria-label="gstApplicable"
                  v-model="adminData.gst"
                >
                  GST Applicable:
                </llp-label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="gstYes"
                      name="gstApplicable"
                      value="yes"
                      checked
                    />
                    <label class="form-check-label" for="gstYes">Yes</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="gstNo"
                      name="gstApplicable"
                      value="no"
                    />
                    <label class="form-check-label" for="gstNo">No</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="gstNumber" :aria-label="gstNumber">
                  GST Number:
                </llp-label>
                <llp-input
                  id="businessAddress"
                  v-model:modelValue="adminData.gstNumber"
                ></llp-input>
              </div>
            </div> -->
              <div class="col">
                <div class="row mt-2 p-0">
                  <div class="col d-flex justify-content-end">
                    <llp-button
                      :load-spinner="submitloadingSpinner"
                      classNames="btn-secondary back-to-btn new-btn"
                      type="submit"
                    >
                      Submit
                    </llp-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, maxLength, numeric } from "@vuelidate/validators";
// import ErrorService from "../../../services/error.service";
import NetworkService from "@/services/network.service";
export default {
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      login_user_role_id:localStorage.getItem('role_id'),
      userId: localStorage.getItem("User_id"),
      submitloadingSpinner:false,
      addUserRole: "",
      roleName: "",
      Admins: [],
      Distributors: [],
      formErrors: {},
      adminData: {
        firstName: "",
        lastName: "",
        mobile: "",
        address: "",
        city: "",
        email: "",
        state: "",
        pinCode: "",
        initialWallet: "",
        // status: "1",
        panNumber: "",
        aadhaarNumber: "",
        businessName: "",
        contactNumber: "",
        businessAddress: "",
        gst: "yes",
        gstNumber: "",
        distributor:"",
        Commission:''
      },
    };
  },
  computed: {
   
    capitalizedRole() {
      return this.roleName.charAt(0).toUpperCase() + this.roleName.slice(1);
    },
  },


 validations() {
  const baseValidations = {
    adminData: {
      firstName: {
        required: helpers.withMessage("First name is required.", required),
          alphaOnly: helpers.withMessage(
          "First name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      lastName: {
        required: helpers.withMessage("Last name is required.", required),
         alphaOnly: helpers.withMessage(
          "Last name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      mobile: {
        required: helpers.withMessage("Mobile number is required.", required),
        numeric: helpers.withMessage("Mobile number must be numeric.", numeric),
        maxLength: helpers.withMessage("Mobile number must be 10 digits.", maxLength(10)),
        validMobile: helpers.withMessage(
          "Mobile number must start with 6, 7, 8, or 9.",
          (value) => (value ? /^[6789]\d{9}$/.test(value) : true)
        ),
      },
      address: {
        required: helpers.withMessage("Address is required.", required),
      },
      city: { required: helpers.withMessage("City is required.", required),
         alphaOnly: helpers.withMessage(
          "City should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
       },
      state: {
        required: helpers.withMessage("State is required.", required),
      },
      email: {
        required: helpers.withMessage("Email is required.", required),
         validFormat: helpers.withMessage(
    "Please enter a valid email address.",
    (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
  )
      },
      pinCode: {
          required: helpers.withMessage("Pin code is required.", required),
           numeric: helpers.withMessage("Pin code must contain only numbers.", numeric),
          maxLength: helpers.withMessage("Pin code must be 6 digits.", maxLength(6)),
        },
    },
  };

  //  Only add Commission validation if logged-in user is Admin
  // if (this.login_user_role_id == 2 && this.addUserRole == 3) {
  //   baseValidations.adminData.Commission = {
  //     required: helpers.withMessage("Commission is required.", required),
  //     validFormat: helpers.withMessage(
  //       "Commission must be a number with up to 2 decimal places (0.00).",
  //       (value) => {
  //         if (!value) return false;
  //         return /^\d+(\.\d{1,2})?$/.test(value);
  //       }
  //     ),
  //     maxCommission: helpers.withMessage(
  //       "Commission must not be more than 99.99.",
  //       (value) => {
  //         if (!value) return false;
  //         return parseFloat(value) <= 99.99;
  //       }
  //     ),
  //   };
  // }
if (this.roleName === 'retailer' && this.login_user_role_id == '2') {
    baseValidations.adminData.distributor = {
      required: helpers.withMessage("Distributor selection is required.", required),
    };
  }
  return baseValidations;
},

 
 mounted() {
    this.addUserRole = this.$route.params.role;
    this.roleName = this.$route.params.role;
    if (this.addUserRole === "admin") {
      this.addUserRole = 2;
    } else if (this.addUserRole === "distributor") {
      this.addUserRole = 3;
    } else if (this.addUserRole === "retailer") {
      this.addUserRole = 4;
    }
    if (this.addUserRole == 3 || this.addUserRole == 4) {
      this.fetchRoles();
    }
  },

  methods: {
    BackToUserDetails() {
      this.$router.back();
    },

    async fetchRoles() {
      try {
        const rolesResponse = await NetworkService.get(
          `/get-users-dropdowns/${this.addUserRole}/${this.userId}`
        );
        if (rolesResponse && rolesResponse.success) {
          this.Admins = rolesResponse.admins || [];
          this.Distributors = rolesResponse.distributors || [];
        } else {
          this.Admins = [];
          this.Distributors = [];
        }
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the roles", "error");
        this.Admins = [];
        this.Distributors = [];
      }
    },

    async addAdmin() {
      this.validator
        .$validate()
        .then(async (isValid) => {
          if (!isValid) return;
          this.submitloadingSpinner = true;
          const addDetails = {
            first_name: this.adminData.firstName,
            last_name: this.adminData.lastName,
            state: this.adminData.state,
            email: this.adminData.email,
            mobile: this.adminData.mobile,
            // status: this.adminData.status === "1" ? "1" : "0",
            role: this.addUserRole,
            created_by: this.userId,
            address: this.adminData.address,
            city: this.adminData.city,
            pincode: this.adminData.pinCode,

          };
          if(this.addUserRole == 3)
          {
            addDetails.parent_id = this.userId;
            addDetails.commission = this.adminData.Commission; 
          }
        if(this.addUserRole == 4)
        {
          addDetails.parent_id=this.adminData.distributor

        }

        if(this.addUserRole == 4 && this.login_user_role_id == 3)
        {
          addDetails.parent_id=this.userId;
        }
          try {
            const response = await NetworkService.post(
              "/add-users",
              addDetails
            );
            this.formErrors = {};
            this.$refs.toast.show(response.data.message,"success");
            this.submitloadingSpinner = false;
            this.$refs.laddadmin.reset();
            setTimeout(() => {
              this.$router.back();
            }, 3000);
          } catch (error) {
            this.submitloadingSpinner =false;
            const apiError = error?.errors;
            if (apiError) {
              this.formErrors = apiError;
            } else {
              this.$refs.toast.show("Unable to add the user details.", "error");
            }
          }
        })
        .catch(() => {
          this.$refs.toast.show("Unable to add the user details", "error");
          this.submitloadingSpinner = false;
        });
    },
  },
};
</script>
